/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import defaultsDeep from 'lodash/defaultsDeep';
import { withNamespaces } from 'react-i18next';
import Spacer from '../../ui/Spacer';
import Pagination from '../../ui/Pagination';
import ResultsGrid from './ResultsGrid';
import ResultsHero from './ResultsHero';
import { spacerMarginCss, spacerPaddingCss } from './index.styles';
import { SafePureComponent } from '../../../utils/SafePureComponent';

export const defaultData = {
  BackgroundColor: { fields: { Value: { value: 'transparent' } } },
  TotalSearchResults: null,
  DisclaimerPriceText: { value: '' },
  PriceDisclaimerTooltip: { value: '' },
  Cards: [],
  Locations: null,
  Headline: { value: '' },
  BodyDescription: { value: '' },
  Page: 1,
  ShowNoResults: false,
  q: '',
};

const PAGINATION_ITEMS_PER_PAGE = 12;

export class ResultsCards extends SafePureComponent {
  fields = defaultsDeep(this.props.fields, defaultData);

  getLocationsLabel(total) {
    const { t } = this.props;
    return total > 1 ? t('locationslabel') : t('locationslabel_singular');
  }

  safeRender() {
    const { t } = this.props;
    const {
      BackgroundColor,
      TotalSearchResults,
      Cards,
      DisclaimerPriceText,
      PriceDisclaimerTooltip,
      Locations,
      Headline,
      BodyDescription,
      Page,
      ShowNoResults,
      q,
    } = this.fields;

    const totalSearchResults = TotalSearchResults ? TotalSearchResults : 0;
    const locationsLabel = this.getLocationsLabel(totalSearchResults);

    return (
      <Spacer
        marginCss={spacerMarginCss}
        paddingCss={spacerPaddingCss}
        backgroundColor={BackgroundColor}
      >
        <ResultsHero fields={{ BackgroundColor, Headline, BodyDescription }} />
        <ResultsGrid
          locationsLabel={locationsLabel}
          fields={{
            BackgroundColor,
            TotalSearchResults,
            Cards,
            DisclaimerPriceText,
            PriceDisclaimerTooltip,
            Locations,
            ShowNoResults,
          }}
        />
        <Pagination
          currentPage={Page}
          totalSearchResults={totalSearchResults}
          searchQuery={q}
          searchQueryParameterName="q"
          itemsPerPage={PAGINATION_ITEMS_PER_PAGE - Cards.length}
          ofLabel={t('of')}
          resultsLabel={locationsLabel}
        />
      </Spacer>
    );
  }
}

ResultsCards.defaultProps = { fields: defaultData };

ResultsCards.propTypes = {
  fields: PropTypes.shape({
    BackgroundColor: PropTypes.shape({
      fields: PropTypes.shape({
        Value: PropTypes.shape({
          value: PropTypes.string,
        }),
      }),
    }),
    DisclaimerPriceText: PropTypes.shape({
      value: PropTypes.string,
    }),
    PriceDisclaimerTooltip: PropTypes.shape({
      value: PropTypes.string,
    }),
    PriceInfoText: PropTypes.shape({
      value: PropTypes.string,
    }),
    TotalSearchResults: PropTypes.number,
    Cards: PropTypes.arrayOf(PropTypes.object),
    Locations: PropTypes.shape({ value: PropTypes.arrayOf(PropTypes.object) }),
  }),
};

ResultsCards.displayName = 'ResultsCards';

export default withNamespaces()(ResultsCards);
